export default "__VITE_ASSET__CSE3I0$q__"